import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { MediaQueryMatchers } from 'react-responsive';
import { Footer } from '@ds/components';

export interface ApplicationLayoutFooterProps {
    dataQa: string;
    locales: string[];
    getCurrentLocale: () => string;
    changeLocale: (locale: string) => void;
    mediaQueryOverrideValues?: Partial<MediaQueryMatchers>;
}

const ApplicationLayoutFooter: FunctionComponent<ApplicationLayoutFooterProps> = ({
    getCurrentLocale,
    locales,
    changeLocale,
    dataQa,
    mediaQueryOverrideValues
}) => {
    const currentLocaleInitializer = getCurrentLocale();

    // useState used to make sure that the footer re-render when onLocaleSelected is called.
    const [currentLocale, setCurrentLocale] = useState<string>();

    // useEffect used to make sure that currentLocale is up to date with the value from getCurrentLocale when the application starts.
    useEffect(() => {
        setCurrentLocale(currentLocaleInitializer);
    }, [currentLocaleInitializer]);

    const onLocaleSelected = useCallback(
        (selectedLocale: string) => {
            changeLocale(selectedLocale);
            setCurrentLocale(selectedLocale);
        },
        [changeLocale]
    );

    return (
        <Footer
            data-qa={dataQa}
            links={Footer.defaultFooterLinks}
            onLocaleSelected={onLocaleSelected}
            currentLocale={currentLocale}
            locales={locales}
            mediaQueryOverrideValues={mediaQueryOverrideValues}
            rebrand2024={true}
        />
    );
};

export default ApplicationLayoutFooter;
